import { FindParamsDefault } from './find-params-default';

export interface FindParamsUsers extends FindParamsDefault {
  identity?: string;
}
